import { css } from '@compiled/react';
import { FormattedMessage } from 'react-intl';

import { media } from '@atlaskit/primitives';

import { Picture } from '@/components/wpl/image/src/image';
import { wacToken } from '@/libraries/design/foundations';

export const NonprofitCalculatorHeading = () => {
	const headingStyles = css({
		fontWeight: 800,
		fontSize: '40px',
		lineHeight: '56px',
		textAlign: 'center',
		margin: 0,
		maxWidth: '688px',
		[media.above.sm]: {
			fontSize: '48px',
			maxWidth: '650px',
		},
		color: wacToken('color.primary.black'),
	});

	const subtitleStyles = css({
		maxWidth: '450px',
		textAlign: 'center',
		margin: '0',
	});

	const imgStyles = css({
		display: 'none',
		position: 'absolute',
		height: '91px',
		width: '94px',
		[media.only.sm]: {
			insetInlineStart: '-5%',
			display: 'block',
		},
		[media.above.md]: {
			insetInlineStart: '-22%',
			display: 'block',
		},
	});

	return (
		<div
			css={css({
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				gap: '8px',
				maxWidth: '768px',
				position: 'relative',
			})}
		>
			<h2 css={headingStyles}>
				<FormattedMessage
					id="NonprofitPage.calculator.heading"
					defaultMessage="Choose the tools and pricing
                    that fit your team"
				/>
			</h2>
			<p css={subtitleStyles}>
				<FormattedMessage
					id="NonprofitPage.calculator.subheading.gwp7869"
					defaultMessage="Use our pricing calculator to get a <bold>discounted pricing estimate</bold> available to nonprofits and social enterprises."
					values={{
						// eslint-disable-next-line react/no-unstable-nested-components
						bold: (chunks) => <span css={css({ fontWeight: 'bold' })}>{chunks}</span>,
					}}
				/>
			</p>
			<Picture
				css={imgStyles}
				image={{
					src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/27360l8wso6a72x4e44yyg66uak8r51f.svg',
					alt: '',
				}}
			/>
		</div>
	);
};
NonprofitCalculatorHeading.displayName = 'TabbedCalculatorHeadingSection';
